import React, {useState, useEffect} from "react";
import {TextField, InputAdornment, Typography, Box, Paper, Pagination, useTheme} from "@mui/material";
import CustomButton from "../../../core/components/ui/CustomButton";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import AddIcon from "@mui/icons-material/Add";
import useBooking from "../hooks/useBooking";
import CustomTableLoaderComponent from "../../../core/components/common/custom-table-loader.component";
import ListBookingComponent from "../components/list-booking.component";
import {useNavigate, useLocation} from "react-router-dom";
import useBookingStore from "../zustand/useBookingStore";
import { RBACUIGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";
import CustomFilterComponent from "../../../core/components/common/custom-filter.component";
import DateRangePickerComponent from "../../../core/components/common/custom-date-range-picker.component";
import moment from "moment";


const headers = ["Booking Type", "Purpose", "Validity", "Status", "Actions"];

const BookingPage = (props) => {
    const {isMobile, breakpoints} = props;

    const navigate = useNavigate();
    const theme = useTheme();
    const location = useLocation();

    const {isFetchingBookingList, bookingListData, listBooking, bookingTypes, getBookingTypes, bookingStatusList, getBookingStatusList, filterBooking, isFilteringBooking} = useBooking();

    const {isBookingStatusUpdated} = useBookingStore();

    const [bookingList, setBookingList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const [filterLabel, setFilterLabel] = useState(null);
    const [filter, setFilter] = useState(null);
    const [bookingTypeFilterValue, setBookingTypeFilterValue] = useState(null);
    const [statusFilterValue, setStatusFilterValue] = useState(null);
    const [purposeFilterValue, setPurposeFilterValue] = useState("");
    const [bookingTypesData, setBookingTypesData] = useState([]);
    const [bookingStatusListData, setBookingStatusListData] = useState([]);
    const [validity, setValidity] = useState(moment().subtract(1, "day").format("YYYY-MM-DD") + "%23" + moment().format("YYYY-MM-DD"));

    const rowsPerPage = 10;
    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const storedOrgIdFromRBACForBusiness = rbacStorage?.state?.currentProfile?.orgId || null;
    const orgIdFromUrlForPortEmployee = new URLSearchParams(location.search).get("org_uid");


    useEffect(() => {

        if (filter) return;
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        const parameters = {
            page: currentPage,
            limit: rowsPerPage,
            orgUID: organizationId
        }
        
        listBooking(parameters);

        getBookingTypes();
        getBookingStatusList();
    }, [storedOrgIdFromRBACForBusiness, orgIdFromUrlForPortEmployee, currentPage])

    useEffect(() => {
        if (bookingTypes) {
            const formattedBookingTypes = bookingTypes.map(type => ({value: type.toLowerCase(), label: type}));
            setBookingTypesData(formattedBookingTypes);
        }
    }, [bookingTypes])

    useEffect(() => {
        if (bookingStatusList) {
            const formattedBookingStatusList = bookingStatusList.map(status => ({value: status.toLowerCase(), label: status}));
            setBookingStatusListData(formattedBookingStatusList);
        }
    }, [bookingStatusList])

    useEffect(() => {
        if (bookingListData) {
            setBookingList(bookingListData?.content);
            setTotalPages(bookingListData?.totalPages);
        }
    }, [bookingListData])

    // useEffect(() => {
    //     const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

    //     if (organizationId && (currentPage || isBookingStatusUpdated)) {
    //         const parameters = {
    //             page: currentPage,
    //             limit: rowsPerPage,
    //             orgUID: organizationId
    //         }
            
    //         listBooking(parameters);

    //     } else if (currentPage || isBookingStatusUpdated) {
    //         const parameters = {
    //             page: currentPage,
    //             limit: rowsPerPage,
    //         }
      
    //         listBooking(parameters);
    //     }
    // }, [currentPage, isBookingStatusUpdated, storedOrgIdFromRBACForBusiness, orgIdFromUrlForPortEmployee])

   useEffect(() => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        let parameters = null;

        if (filter === "booking_type" && bookingTypeFilterValue) {
            parameters = { searchFor: "booking_type", searchVal: bookingTypeFilterValue };
        } else if (filter === "status" && statusFilterValue) {
            parameters = { searchFor: "status", searchVal: statusFilterValue };
        } else if (filter === "validity" && validity) {
            parameters = { searchFor: "validity", searchVal: validity };
        }

        if (parameters) {
            parameters.page = currentPage;           // always start at page 1
            parameters.limit = rowsPerPage; // use your rowsPerPage state/prop

            if (organizationId) {
            parameters.orgUID = organizationId;
            }

            filterBooking(parameters);
        }
        }, [
        filter,
        bookingTypeFilterValue,
        statusFilterValue,
        validity,
        storedOrgIdFromRBACForBusiness,
        orgIdFromUrlForPortEmployee,
        rowsPerPage,
        currentPage
    ]);


    

    const handleChangePagination = (event, page) => { 
        setCurrentPage(page); 
    }

    const handleClickOpen = () => {
        if (orgIdFromUrlForPortEmployee && !storedOrgIdFromRBACForBusiness) {
            navigate("/organization/view/bookings/create?org_uid=" + orgIdFromUrlForPortEmployee);

        } else {
            navigate("/bookings/create");
        }
    }

    const searchForOptions = [
        {value: "booking_type", label: "Booking Type"},
        {value: "status", label: "Status"},
        {value: "purpose", label: "Purpose"},
        {value: "validity", label: "Validity"}
    ]

    const handleSearchForOption = (selectedOption, type) => {
        if (selectedOption && type === "booking_type") {
            setFilter(selectedOption.value);
            setFilterLabel(selectedOption.label);
            setStatusFilterValue(null);
            setPurposeFilterValue("");
            setValidity(null);
            

        } else if (selectedOption && type === "status") {
            setFilter(selectedOption.value);
            setFilterLabel(selectedOption.label);
            setBookingTypeFilterValue(null);
            setPurposeFilterValue("");
            setValidity(null);

        } else if (selectedOption && type === "validity") {
            setFilter("validity");
            setFilterLabel("Validity");
            setBookingTypeFilterValue(null);
            setStatusFilterValue(null);
            setPurposeFilterValue("");
            setValidity(moment().subtract(1, "day").format("YYYY-MM-DD") + "%23" + moment().format("YYYY-MM-DD"));

        } else if (selectedOption && type === "purpose") {
            setFilter(selectedOption.value);
            setFilterLabel("Purpose");
            setBookingTypeFilterValue(null);
            setStatusFilterValue(null);
            setValidity(null);

        } else {    
            handleSearchForClearFilter();
        }
    }

    const handleSearchValOption = (selectedOption, type) => {
        if (selectedOption && type === "type") {
            setStatusFilterValue(null);
            setBookingTypeFilterValue(selectedOption.label);
          
        } else if (selectedOption && type === "status") {
            setBookingTypeFilterValue(null);
            setStatusFilterValue(selectedOption.label); 

        } else {    
            handleSearchValClearFilter();
        }
    }

    const handleTextfield = (e) => {
        setBookingTypeFilterValue(null);
        setStatusFilterValue(null);
        setPurposeFilterValue(e.target.value);
    }

    const handleKeyPress = (e) => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (e.keyCode === 13 || e.key === "Enter") {
            if (organizationId && filter && purposeFilterValue) {
                const parameters = {
                    searchFor: filter,
                    searchVal: purposeFilterValue,
                    orgUID: organizationId
                };

                filterBooking(parameters);

            } else if (filter && purposeFilterValue) {
                const parameters = {
                    searchFor: filter,
                    searchVal: purposeFilterValue,
                };

                filterBooking(parameters);
            }
        }
    }

    const handleSearchForClearFilter = (e) => {
        setFilter(null);
        setFilterLabel(null);

        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (organizationId) {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
                orgUID: organizationId
            }

            listBooking(parameters);

        } else {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
            }

            listBooking(parameters);
        }
    }

    const handleSearchValClearFilter = (e) => {
        setBookingTypeFilterValue(null);
        setStatusFilterValue(null);
        setPurposeFilterValue("");
        setValidity(null);

        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;
        
        if (organizationId) {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
                orgUID: organizationId
            }

            listBooking(parameters);

        } else {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
            }

            listBooking(parameters);
        }
    }


    return (
        <>        
            <Box sx={{textAlign: "start"}}>
                <CustomTypography 
                    variant="h3"
                    text={"Bookings"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />

                <CustomTypography 
                    variant="subtitle1"
                    text={"View, track, and manage all booking requests"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />
            </Box>
            
            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3}}>
                <Box sx={{display: "flex", justifyContent: "right"}}>
                    <CustomFilterComponent
                        width={200}
                        isSearchable={true}
                        isClearable={true}
                        filterLabel={(filterLabel === "Booking Type") ? "Booking Type" : (filterLabel === "Status") ? "Status" : (filterLabel === "Purpose") ? "Purpose" : (filterLabel === "Validity") ? "Validity" : null}
                        filterOptions={searchForOptions}
                        onChange={selectedOption => handleSearchForOption(selectedOption, selectedOption?.value || null)}
                        isSearchForFilter={true}
                        isSearchValue={false}
                    />

                    {(filterLabel === null || filterLabel === "Booking Type") && 
                        <CustomFilterComponent
                            width={300}
                            isSearchable={true}
                            isClearable={true}
                            filterLabel={filterLabel}
                            filterOptions={bookingTypesData}
                            onChange={selectedOption => handleSearchValOption(selectedOption, "type")}
                            isSearchForFilter={false}
                            isSearchValue={true}
                            isDisabled={false}
                        />
                    }

                    {(filterLabel === "Status") && 
                        <CustomFilterComponent
                            width={300}
                            isSearchable={true}
                            isClearable={true}
                            filterLabel={filterLabel}
                            filterOptions={bookingStatusListData}
                            onChange={selectedOption => handleSearchValOption(selectedOption, "status")}
                            isSearchForFilter={false}
                            isSearchValue={true}
                            isDisabled={false}
                        />
                    }
                    
                    {filterLabel === "Purpose" &&
                        <TextField
                            value={purposeFilterValue}
                            placeholder={"Input Purpose..."}
                            variant="outlined"
                            autoComplete="off"  
                            onChange={handleTextfield}
                            onKeyDown={handleKeyPress}
                            slotProps={{
                                input: {
                                    style: {
                                        padding: "10px",
                                        fontSize: 14,
                                        fontStyle: 'italic'
                                    },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Typography sx={{fontSize: 14, color: theme.typography.primary, opacity: 0.85, fontStyle: "normal"}}>
                                                Purpose:
                                            </Typography>
                                        </InputAdornment>
                                    )
                                }
                            }}
                            sx={{
                                marginRight: "10px", 
                                "& .MuiInputBase-root": {
                                    height: 42, 
                                    backgroundColor: "transparent", 
                                    width: 300, 
                                    borderColor: "#dce8f5"
                                },
                                "& .MuiOutlinedInput-root": {
                                    height: 42,
                                    backgroundColor: "transparent",
                                    "& fieldset": {
                                        borderColor: "#dce8f5",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: theme.palette.primary.main, 
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: `0 0 0 1px ${theme.palette.primary.main}`,
                                    }
                                },
                            }}  
                        /> 
                    }

                    {filterLabel === "Validity" && 
                        <>
                            <DateRangePickerComponent
                                variant="booking_page"
                                initialStartDate={moment().subtract(1, "day").format("YYYY-MM-DD")}
                                initialEndDate={moment().format("YYYY-MM-DD")}  
                                ranges={{
                                    "Last 7 Days": [moment().subtract(6, 'days'), moment()],
                                    "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
                                    "Last 90 Days": [moment().subtract(89, "days").startOf("day"), moment().endOf("day")],
                                    "This Month": [moment().startOf("month"), moment().endOf("month")]
                                }}
                                onDateRangeChange={(start, end) => {
                                    const formattedStart = moment(start).format('YYYY-MM-DD');
                                    const formattedEnd = moment(end).format('YYYY-MM-DD');

                                    setValidity(formattedStart + "%23" + formattedEnd);
                                }}
                            /> &nbsp;&nbsp;
                        </>
                    }

                    <RBACUIGuard requiredPermission={permissions.booking.CREATE_BOOKING}>
                        <CustomButton 
                            variant="contained" 
                            startIcon={<AddIcon fontSize="small" />}
                            label="Add Booking"
                            customStyles={{fontSize: 14}}
                            onClick={handleClickOpen}
                        />
                    </RBACUIGuard>
                    
                </Box>

                {(isFetchingBookingList || isFilteringBooking) ?
                    <Box sx={{mt: 3}}>
                        <CustomTableLoaderComponent 
                            headers={headers} 
                            hasAction={false}
                        /> 
                    </Box>
                :   
                    <Box sx={{mt: 3, mb: (bookingList?.length === 0 || bookingList === undefined) ? 2 : {}}}>
                        <ListBookingComponent 
                            headers={headers} 
                            data={bookingList} 
                            isMobile={isMobile}
                            breakpoints={breakpoints}
                        />
                
                        {bookingList?.length > 0 &&
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={handleChangePagination}
                                sx={{
                                    margin: "auto",
                                    width: "fit-content",
                                    paddingTop: 3,
                    
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        backgroundColor: "#0b99da",      
                                        color: "#fff",               
                                    }
                                }}
                            />
                        }
                    </Box>
                }
            </Paper>
       </>
    )
}

export default BookingPage